import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  close: <PortalMessage id='t.app.close' defaultMessage='Chiudi' />,
  back: <PortalMessage id='t.app.back' defaultMessage='Indietro' />,
  titlePageAdmin: <PortalMessage id='t.app.settings.personalData.titlePage.admin' defaultMessage='Amministratore' />,
  titlePageUser: (
    <PortalMessage id='t.app.settings.personalData.titlePage.user' defaultMessage='Incaricato Secondario' />
  ),
  support: <PortalMessage id='t.app.support' defaultMessage='Assistenza' />,
  titleNav: <PortalMessage id='t.app.personalData.titleNavigation' defaultMessage='Dati personali' />,
  titleCardData: <PortalMessage id='t.app.common.userData' defaultMessage='I tuoi dati' />,
  name: <PortalMessage id='t.app.name' defaultMessage='Nome' />,
  surname: <PortalMessage id='t.app.surname' defaultMessage='Cognome' />,
  email: <PortalMessage id='t.app.email' defaultMessage='Email' />,
  phone: <PortalMessage id='t.app.phone' defaultMessage='Telefono' />,
  password: <PortalMessage id='t.app.password' defaultMessage='Password' />,
  privacy: <PortalMessage id='t.app.privacy' defaultMessage='Consensi privacy' />,
  deleteAccount: <PortalMessage id='t.app.personalData.deleteAccount' defaultMessage='Eliminazione utenza' />,
  deleteAccountDescription: (
    <PortalMessage
      id='t.app.personalData.deleteAccount.subtitle'
      defaultMessage='Eliminando l’utenza i tuoi dati saranno cancellati, per poter accedere a Nexi Business dovrai registrarti di nuovo.'
    />
  ),
  yes: <PortalMessage id='t.app.yes' defaultMessage='Si' />,
  no: <PortalMessage id='t.app.no' defaultMessage='No' />,
  edit: <PortalMessage id='t.app.edit' defaultMessage='Modifica' />,
  showMore: <PortalMessage id='t.app.show' defaultMessage='Mostra' />,
  confirm: <PortalMessage id='t.app.confirm' defaultMessage='Mostra' />,
  modalPrivacyModalTitle: (
    <PortalMessage id='t.app.registration.consents.titlePage' defaultMessage='Consensi privacy' />
  ),
  requestDeletion: <PortalMessage id='t.app.requestDeletion' defaultMessage='RICHIEDI ELIMINAZIONE' />,
  modalPrivacyModalMerchantFlowCardTitle: (
    <>
      <PortalMessage
        id='t.app.registration.consents.title'
        defaultMessage='Consenso al trattamento dei dati personali'
      />
      .
    </>
  ),
  modalPrivacyModalMerchantFlowCardDescription: (
    <PortalMessage
      id='t.app.personalData.modalPrivacyModalMerchantFlowCardDescription'
      defaultMessage='Per garantirti l’accesso a tutti i nostri servizi abbiamo bisogno del tuo consenso.'
    />
  ),

  consent1: (
    <PortalMessage id='t.app.registration.consents.consent1.title' defaultMessage='Per rimanere sempre aggiornato' />
  ),
  consent1Subtitle: (
    <PortalMessage
      id='t.app.registration.consents.consent1.subtitle'
      defaultMessage='Desidero ricevere comunicazioni commerciali da Nexi relative a promozioni e offerte di Nexi e dei suoi Partner commerciali.'
    />
  ),
  consent2: (
    <PortalMessage id='t.app.registration.consents.consent2.title' defaultMessage='Per migliorare il servizio' />
  ),
  consent2Subtitle: (
    <PortalMessage
      id='t.app.registration.consents.consent2.subtitle'
      defaultMessage='Autorizzo ad effettuare indagini di mercato o customer satisfaction relative ai servizi e alle attività svolte da Nexi.'
    />
  ),
  consent3: (
    <PortalMessage
      id='t.app.registration.consents.consent3.title'
      defaultMessage='Per attività di promozione commerciale da terzi'
    />
  ),
  consent3Subtitle: (
    <PortalMessage
      id='t.app.registration.consents.consent3.subtitle'
      defaultMessage='Autorizzo a trasferire i miei dati ad aziende terze, selezionate da Nexi, per finalità commerciali.'
    />
  ),
  // ISP
  titleCardFiscalCode: <PortalMessage id='t.app.personalData.titleCardFiscalCode' defaultMessage='Codice Fiscale' />,
  status: <PortalMessage id='t.app.status' defaultMessage='Stato' />,
  fiscalCodeNotPresent: (
    <PortalMessage id='t.app.personalData.fiscalCodeNotPresent' defaultMessage='Codice fiscale non presente' />
  ),
  verified: <PortalMessage id='t.app.verified' defaultMessage='Verificato' />,
  valid: <PortalMessage id='t.app.valid' defaultMessage='Valido' />,
  notValid: <PortalMessage id='t.app.notValid' defaultMessage='Non valido' />,
  add: <PortalMessage id='t.app.add' defaultMessage='Aggiungi' />,

  titleCardISPEnabled: (
    <PortalMessage
      id='t.app.personalData.titleCardISPEnabled'
      defaultMessage='Sei abilitato agli storni sui punti vendita Intesa Sanpaolo'
    />
  ),
  textCardISPEnabled: (
    <PortalMessage
      id='t.app.personalData.textCardISPEnabled'
      defaultMessage='I contatti validi e certificati ti permettono di stornare le transazioni anche sui punti vendita Intesa Sanpaolo.'
    />
  ),
  titleCardISPNotEnabled: (
    <PortalMessage
      id='t.app.personalData.titleCardISPNotEnabled'
      defaultMessage='La funzionalità storni non è attiva sui punti vendita Intesa Sanpaolo'
    />
  ),
  textCardISPNotEnabled: (
    <PortalMessage
      id='t.app.personalData.textCardISPNotEnabled'
      defaultMessage='Per stornare, devi avere il contratto del servizio a distanza Intesa Sanpaolo - My Key. Se lo hai e hai un numero di telefono certificato e un’email validata, inseriscili nel tuo profilo. In alternativa, contatta la Filiale Digitale al 800 303 303 (dall’estero: +39 011 8019 200).'
    />
  ),
  textCardISPFiscalCodeNotInRecord: (
    <PortalMessage
      id='t.app.personalData.textCardISPFiscalCodeNotInRecord'
      defaultMessage='Contatta la Filiale Digitale di Intesa Sanpaolo al 800 303 303 dall’Italia (oppure +39 011 8019 200 dall’estero) per verificare la tua posizione.'
    />
  ),

  // FLOWMESSAGE
  sentNewOTPCode: (
    <PortalMessage id='t.app.error.toast.sentNewOTPCode' defaultMessage='Ti abbiamo inviato un nuovo codice.' />
  ),
  sentNewDoubleOTPCode: (
    <PortalMessage id='t.app.error.toast.sentNewDoubleOTPCode' defaultMessage='Ti abbiamo inviato dei nuovi codici.' />
  ),
  wrongCodeError: <PortalMessage id='t.app.verifyNumber.error.invalidCode' defaultMessage='Codice errato' />,
  wrongCodeToast: (
    <PortalMessage
      id='t.app.personalData.error.toast.otpCodeWrong'
      defaultMessage='Il codice inserito non è corretto. Riprova.'
    />
  ),
  wrongDoubleCodeToast: (
    <PortalMessage
      id='t.app.personalData.error.toast.wrongDoubleCode'
      defaultMessage='Il codice inserito non è corretto. Riprova.'
    />
  ),
  wrongCodeLastAttempt: (
    <PortalMessage
      id='t.app.personalData.error.toast.wrongCodeLastAttempt'
      defaultMessage='Codice errato. Hai ancora <b>1 tentativo</b> a disposizione.'
    />
  ),
  lastAttemptDoubleAvailable: (
    <PortalMessage
      id='t.app.error.toast.lastAttemptDoubleAvailable'
      defaultMessage='Codici errati. Hai ancora <b>1 tentativo</b> a disposizione.'
    />
  ),
  lastAttemptAvailable: (
    <PortalMessage
      id='t.app.error.toast.lastAttemptAvailable'
      defaultMessage='Codice errato. Hai ancora <b>1 tentativo</b> a disposizione.'
    />
  ),
  finishedAttempts: (
    <PortalMessage
      id='t.app.personalData.error.toast.finishedAttempts'
      defaultMessage='I codici inseriti non sono corretti e hai esaurito i tentativi. Genera dei nuovi codici.'
    />
  ),
  expiredCodes: (
    <PortalMessage
      id='t.app.personalData.error.toast.expiredCodes'
      defaultMessage='I codici inseriti risultano scaduti. Genera dei nuovi codici.'
    />
  ),
  passwordHistoryError: (
    <PortalMessage
      id='t.app.error.toast.passwordHistoryError'
      defaultMessage='La password che hai inserito è già stata utilizzata precedentemente. <br />Scegli una password diversa.'
    />
  ),
  fiscalCodeFormatError: (
    <PortalMessage
      id='t.app.personalData.editFiscalCode.fiscalCodeFormatError.error.format'
      defaultMessage='Il codice fiscale risulta non valido'
    />
  ),
  errorEmailUsed: <PortalMessage id='t.app.error.errorEmailUsed' defaultMessage='Modifica l’email inserita' />,
  errorEmailUsedToast: <PortalMessage id='t.app.error.errorEmailUsed.toast' defaultMessage='L’email inserita non è valida. Riprova.' />,
  errorPhoneNotValidToast: <PortalMessage id='t.app.error.errorPhoneNotValid.toast' defaultMessage='Il dato inserito non è valido, riprova.' />,
  alreadyInUsePhoneNumberToast: (
    <PortalMessage
      id='t.app.error.phoneNumberAlreadyInUseToast'
      defaultMessage='Il numero di telefono inserito non può corrispondere a quello attualmente in uso.'
    />
  ),
  wrongEmailToast: (
    <PortalMessage id='t.app.error.wrongEmailToast' defaultMessage='L’email attuale inserita non corrisponde a quella che utilizzi per accedere a Nexi Business.' />
  ),
  dataNotValid: (
    <PortalMessage id='t.app.error.dataNotValid' defaultMessage='Il dato inserito non è valido, riprova.' />
  ),
  emailMatchError: (
    <PortalMessage
      id='t.app.personalData.changeEmail.error.emailMatch'
      defaultMessage='La nuova email inserita non può corrispondere a quella attualmente in uso.'
    />
  )
}

export default formattedMessage
